module.exports = __webpack_public_path__ + "static/media/add-timeblock.6a43bfa1.svg";